import React from 'react';
import { getOrgTermsContent } from '../../../../content/utils.js';
import PageHeader from '../../PageHeader.js';
import BreadCrumbs from '../../../BreadCrumbs.jsx';
import ProjectBreadcrumbIcon from '../../../icons/ProjectBreadcrumbIcon.jsx';
import { ProjectLink, ProjectsLink } from '../../../links/index.jsx';

const ProjectFormHeader = ({ project }) => {
  return (
    <PageHeader flex>
      <BreadCrumbs icon={<ProjectBreadcrumbIcon />}>
        <ProjectsLink>{getOrgTermsContent('projects')}</ProjectsLink>

        {project ? (
          <ProjectLink projectId={project.id}>{project.name}</ProjectLink>
        ) : null}
        {project ? <span>Edit {getOrgTermsContent('project')}</span> : null}

        {!project ? <span>Add {getOrgTermsContent('project')}</span> : null}
      </BreadCrumbs>
    </PageHeader>
  );
};

export default ProjectFormHeader;
